import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupporterService {

  constructor(
    private _http: HttpClient
  ) {}

  public getSupporters(): Observable<any>{
    return this._http.get(environment.apiEndpoint + '/api/supporters').pipe(
      map(
        (res:any) => {
          if(res){
            res.forEach((supporter, index)=>{
              if(supporter.image) res[index].image=environment.apiEndpoint+'/storage/supporters/'+supporter.image;
            });
          }
          return res;
        }
      )
    );
  }

  public getSupportersRnd(): Observable<any>{
    return this._http.get(environment.apiEndpoint + '/api/supportersRnd').pipe(
      map(
        (res:any) => {
          if(res){
            res.forEach((supporter, index)=>{
              if(supporter.image) res[index].image=environment.apiEndpoint+'/storage/supporters/'+supporter.image;
            });
          }
          return res;
        }
      )
    );
  }

  public getSupporter(supporterId:number):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/supporter/'+supporterId).pipe(
      map(
        (res:any)=>{
          if(res.image) res.image=environment.apiEndpoint+'/storage/supporters/'+res.image;
          return res;
        }
      )
    );
  }
}
